module.exports = {
  "country": "NO",
  "artist": "Secret Garden",
  "song": "Nocturne",
  "year": "1995",
  "place": "1",
  "spotify": "6bk11TH82XrT5QUC1gDw9A"
};